module.exports = __webpack_public_path__ + "static/img/5.9cf85af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/5.jpg
// module id = 8FcD
// module chunks = 0